export const BulkEditOpenerHook: {
  el?: HTMLElement
  mounted: () => void
  destroyed: () => void
} = {
  mounted() {
    if (!this.el) {
      return
    }

    const button = this.el.querySelector('button')
    if (!button) {
      return
    }

    const tableId = this.el.dataset.tableId
    const editBase = this.el.dataset.editBase
    if (!tableId || !editBase) {
      console.error('BulkEditOpenerHook requires data-table-id and data-edit-base')
      return
    }

    button.addEventListener('click', () => {
      const table = document.querySelector(`#${tableId}`)
      if (!table) {
        console.error(`Could not find table #${tableId}`)
        return
      }

      const rows = table.querySelectorAll('tbody tr')
      const ids: string[] = []

      rows.forEach((row) => {
        const firstCell = row.querySelector('td')
        if (firstCell) {
          const id = firstCell.textContent?.trim()
          if (id) {
            ids.push(id)
          }
        }
      })

      if (ids.length === 0) {
        alert('No rows found to open')
        return
      }

      const confirmMessage = `This will open ${ids.length} tabs. Continue?`
      if (!confirm(confirmMessage)) {
        return
      }

      ids.forEach((id, index) => {
        const url = `${editBase}/${id}/edit`

        setTimeout(() => {
          window.open(url, '_blank')
        }, index * 100)
      })
    })
  },

  destroyed() {
    // Cleanup is automatic since we're adding event listeners to elements that will be removed
  },
}
